<script setup lang="ts">
import { ChevronsUpDown, Settings, LogOut } from 'lucide-vue-next'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/shadcn-ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/shadcn-ui/sidebar'
import type { IAppSidebar } from '~/components/layouts/sidebar/types'
import type { IUsers } from '~/gateway/users/users.types'

interface Props {
  user: IUsers.Model<'user'>
}

interface Emits {
  (e: 'signOut'): void
}

defineProps<Props>()

defineEmits<Emits>()

const userNavItems: IAppSidebar.NavItem[] = [
  {
    title: 'Settings',
    icon: Settings,
    url: '/settings',
  },
]

const { isMobile } = useSidebar()
</script>

<template>
  <SidebarMenu>
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <SidebarMenuButton
            size="lg"
            class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            <div class="grid flex-1 text-left text-sm leading-tight">
              <span class="truncate font-semibold">{{ user.name }}</span>
              <span class="truncate text-xs">{{ user.email }}</span>
            </div>
            <ChevronsUpDown class="ml-auto size-4" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          class="w-[--reka-dropdown-menu-trigger-width] min-w-56 rounded-lg"
          :side="isMobile ? 'bottom' : 'right'"
          align="end"
          :side-offset="4"
        >
          <DropdownMenuGroup>
            <DropdownMenuItem v-for="item in userNavItems" :key="item.title">
              <NuxtLink :to="item.url">
                <component :is="item.icon" />
                {{ item.title }}
              </NuxtLink>
            </DropdownMenuItem>

            <DropdownMenuItem @click="$emit('signOut')">
              <LogOut />
              Log out
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  </SidebarMenu>
</template>
